import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Url from '../../data/url';
import { TALENT_ARR } from '../../data/define';
import ToolTip from '../common/ToolTip';
import IntelligenceRankLabel from '../common/IntelligenceRankLabel';
import { calculateIntelligenceGrade } from '../../utility/utilities';
import { useTranslation } from '../../hook/useTranslation';

function ReportCore({ result = [], thumbnails = [] }) {
  const navigate = useNavigate();
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const { t } = useTranslation();

  // 등급 맵 미리 계산
  const gradeMap = calculateIntelligenceGrade(result);

  const handleGoDetail = useCallback(
    (intelligenceId, label) => {
      navigate(Url.ReportDetail, {
        state: {
          results: result,
          intelligenceId: intelligenceId,
          thumbnails: thumbnails,
          label: label,
        },
      });
    },
    [result, thumbnails, navigate]
  );

  return (
    <div className="w-full relative pt-[20px] pb-[20px] min-h-[300px]">
      <div className="flex items-center justify-start gap-2 mb-[20px]">
        <div className="text-[#1C1C1C] font-[700] text-[20px] text-left">
          {t('report.core.title')}
        </div>
        <ToolTip open={tooltipOpen} setOpen={setTooltipOpen} text={t('report.core.tooltip')} />
      </div>
      <div className="w-full flex flex-col gap-[24px] items-center justify-between">
        {result &&
          result?.length > 0 &&
          result
            ?.filter((item) => item.final_summary !== null)
            ?.sort((a, b) => (b.score || 0) - (a.score || 0))
            ?.map((item) => {
              const intelliThumbnails = thumbnails?.find(
                (intelli) => intelli.intelligence === item.intelligence
              );
              const repThumbnail =
                intelliThumbnails?.indv_thumbs[intelliThumbnails.indv_thumbs.length - 1];
              // 등급 계산
              const grade = gradeMap[item.intelligence];
              const label = grade || null; // '우수', '일반', '보완' 또는 null
              const talent = TALENT_ARR.find((tlt) => tlt.id === item.intelligence);
              return (
                <div
                  key={item.intelligence}
                  className="w-full rounded-[10px] bg-white flex flex-col gap-2 items-start justify-start"
                >
                  {/* 1. Title */}
                  <div className="font-[700] text-[16px] text-[#1C1C1C] text-left w-full break-words">
                    {talent
                      ? t('report.summary.intelligence', { label: t('talent.' + talent.key) })
                      : ''}
                  </div>
                  {/* 2. Label & More Button */}
                  <div className="w-full flex justify-between items-center">
                    {label ? <IntelligenceRankLabel label={label} /> : <div />}
                    <button
                      type="button"
                      className="text-[#767676] text-[12px]"
                      onClick={() => handleGoDetail(item.intelligence, label)}
                    >
                      {t('report.core.more')}
                    </button>
                  </div>
                  {/* 3. Thumbnail & Summary Content Row */}
                  <div className="w-full flex items-start justify-start gap-2">
                    <div className="w-[90px] shrink-0">
                      {repThumbnail?.indv_thumb_url ? (
                        <img
                          src={repThumbnail?.indv_thumb_url}
                          className="object-cover shrink-0 h-[90px] w-[90px] rounded-[10px]"
                          alt="thumbnail"
                        />
                      ) : (
                        <div className="h-[90px] w-[90px] rounded-[10px] bg-[#F8F8F8]" />
                      )}
                    </div>
                    <div className="grow bg-[#F8F8F8] p-[15px] text-left rounded-[16px] text-[#363636] text-[14px] font-[400] leading-[20px] h-[90px] max-h-[90px] overflow-hidden min-w-0">
                      <div
                        style={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 3,
                        }}
                      >
                        {item?.final_summary || t('report.core.empty')}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
      </div>
    </div>
  );
}

export default ReportCore;
